<template>
  <div class="user">
    <!--    <div class="photo">-->
    <!--      <img src="static/img/faces/face-2.jpg"/>-->
    <!--    </div>-->
    <div class="info">
      <a data-toggle="collapse" @click="toggleMenu" href="javascript:void(0)">
        <span>
          {{ username }}
          <b class="caret"></b>
        </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <el-collapse-transition>
          <ul class="nav" v-show="!isClosed">
            <li>
              <a href="#" @click.prevent="logoutUser">
                <span class="sidebar-mini">L</span>
                <span class="sidebar-normal">Logout</span>
              </a>
            </li>
          </ul>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

export default {
  components: {
    [CollapseTransition.name]: CollapseTransition
  },
  mounted () {
    this.setCurrentUser();
  },
  computed: {
    ...mapGetters(['user']),
    username: function () {
      return this.user ? this.user.name : ''
    }
  },
  data () {
    return {
      isClosed: true
    }
  },
  methods: {
    ...mapActions(['logout', 'setCurrentUser']),
    logoutUser: function () {
      this.logout().then(() => this.$router.push({name: 'login'}))
    },
    toggleMenu () {
      this.isClosed = !this.isClosed
    }
  }
}
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/UserMenu.vue